/* eslint-disable default-param-last */
export const checkoutInfoReducer = (state = false, action) => {
  switch (action.type) {
    case 'SET_CHECKOUT_OPEN':
      return action.isCheckoutOpen;
    default:
      return state;
  }
};
